<template>
<div>
    <div class="panel panel-default">
        <div class="panel-heading">
            Monitoring
        </div>
        <div class="panel-body">
            <form class="form-horizontal" role="form" @submit.prevent="updateView">
            <div class="form-group">
                <label class="col-md-4 control-label">Monitor Traffic</label>

                <div class="col-md-6">
                    <select name="monitor" class="form-control" v-model="view.monitor">
                        <option :value="1">True</option>
                        <option :value="0">False</option>
                    </select>
                    <span class="help-block">Be alerted for tracking anomalies.</span>
                </div>
            </div>
            <div class="form-group" v-if="view.monitor == 1">
                <label class="col-md-4 control-label">Snooze Notifications</label>

                <div class="col-md-6">
                    <select v-if="! view.snooze_notifications_until" name="monitor" class="form-control" v-model="view.snooze_notifications_until">
                        <option :value="null">Off</option>
                        <option :value="fortyEightHoursFromNow">48 Hours</option>
                        <option :value="sevenDaysFromNow">1 Week</option>
                    </select>
                    <div v-else>
                        Notifications snoozed until <strong>{{view.snooze_notifications_until}}</strong>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-offset-4 col-md-6">
                    <button type="submit" class="btn btn-primary" :class="{'btn-loading': loading}" :disabled="loading">
                        Save
                    </button>
                </div>
            </div>
        </form>
        </div>
    </div>
</div>
</template>

<script>
import {
	mapGetters
} from 'vuex';

export default {
	data() {
		return {
            loading: false,
		}
	},

	computed: {
		...mapGetters('client', {
			'client': 'activeClient',
            'isAdmin': 'isAdmin',
            'view': 'activeView'
		}),

        fortyEightHoursFromNow() {
            return moment().add(2, 'days').format('YYYY-MM-DD');
        },

        sevenDaysFromNow() {
            return moment().add(7, 'days').format('YYYY-MM-DD');
        }
	},

	methods: {
        updateView() {
			let view = this.view;
            this.loading = true;
			this.$store.dispatch('client/updateGaView', {
					view: view
				})
				.then((response) => {
					this.loading = false;
                    Bus.$emit('show-success-alert', response.message);
				})
				.catch((error) => {
					console.log(error);
				});
		}
	}
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/GaViewMonitoring.vue